import React from 'react';
import './HierarchySection.scss';

const HierarchySection = ({ summary }) => {
  if (!summary) return null;

  return (
    <section className="hierarchy-section">
      <h3 className="hierarchy-heading">Seitenübersicht</h3>
      <p>
        <strong className="label">Titel:</strong>{' '}
        <span className="value">{summary.page_title || 'N/A'}</span>
      </p>
      <p>
        <strong className="label">ObjId:</strong>{' '}
        <span className="value">{summary.page_id || 'N/A'}</span>
      </p>
      <p>
        <strong className="label">Pfad:</strong>{' '}
        <span className="value">{summary.page_path || 'N/A'}</span>
      </p>

      {summary.last_cleanup_at ? (
        <p className="date-info">
          <strong>Letzte Prüfung:</strong> {summary.last_cleanup_at}
        </p>
      ) : (
        <p className="date-info">
          <strong>Status:</strong> Noch nie analysiert
        </p>
      )}
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-label">Gesamtobjekte</div>
          <div className="stat-value all">{summary.total_objects}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Pages</div>
          <div className="stat-value all">{summary.page_all_count}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Assets</div>
          <div className="stat-value all">{summary.asset_all_count}</div>
        </div>
      </div>
      <h2>Details</h2>
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-label">Nicht verwendete Assets</div>
          <div className="stat-value all">{summary.asset_unused_count}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Fehlerhafte Assets</div>
          <div className="stat-value all">{summary.asset_faulty_count}</div>
        </div>
        <div className="stat-item">
          <div className="stat-label">Fehlerhafte Widgets</div>
          <div className="stat-value all">{summary.widget_faulty_count}</div>
        </div>
      </div>
    </section>
  );
};

export default HierarchySection;
